import {useMemo} from 'react';
import {useModalToggle} from '.';

type CartUIType = {
  isCartOpen: boolean;
  openCart: () => void;
  closeCart: () => void;
  toggleCart: () => void;
};

export default function useCartUI(): CartUIType {
  const {
    isOpen: isCartOpen,
    openModal: openCart,
    closeModal: closeCart,
    toggleModal: toggleCart,
  } = useModalToggle('cart');

  return useMemo(
    () => ({
      isCartOpen,
      openCart,
      closeCart,
      toggleCart,
    }),
    [closeCart, isCartOpen, openCart, toggleCart],
  );
}
